// extracted by mini-css-extract-plugin
export default {"sub_footer":"SubFooter_sub_footer__JSDjE"};